<template>
  <section class="pa-section pa-section-character-status-index">
    <div class="logo-header">
      <CharacterStatusIndexLogo />
    </div>

    <div class="local-date">
      <p>異世界地球時間：{{dateTime}}</p>
    </div>

    <div class="infomation-items">
      <div class="infomation-set infomation-set-chapter">
        <div class="title-logo">
          <StatusIndexChapterTitle />
        </div>
        <div class="chapter-banner">
          <ChapterBanner :characterLevelSlug="characterLevelSlug" />
        </div>
        <div class="progress-bar">
          <p class="initial-text">--</p>
          <p class="value-text">{{progressText}}</p>
          <div class="progress-bar-value" ref="progressBarValue"></div>
        </div>
      </div>

      <div class="infomation-set infomation-set-length-of-stay">
        <div class="title-logo">
          <StatusIndexLengthOfStay />
        </div>
        <div class="stay-counter">
          <div class="value-field">{{lengthOfStay}}</div>
          <div class="title-field">滞在日数</div>
        </div>
      </div>

      <div class="infomation-set infomation-set-item-store">
        <div class="title-logo">
          <StatusIndexItemsTitle />
        </div>
        <div class="item-list">
          <template v-for="characterItemStore in characterItemStoreList">
            <CharacterItemListItem :key="characterItemStore.item.slug" :characterItemStore="characterItemStore" />
          </template>
          <template v-if="!hasVisibleItems">
            <p class="no-items">未取得</p>
            <p class="no-item-description">チャプターを進めるとアイテムが手に入ります。</p>
          </template>
        </div>
      </div>

      <div class="infomation-set infomation-set-sonar">
        <div class="title-logo">
          <StatusIndexSonarTitle />
        </div>

        <div class="sonar-image">
          <StatusIndexSonarImage />
        </div>
        <div class="status-text">
          <p>未探索</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CharacterStatusIndexLogo from '@/components/Pages/Home/CharacterStatusIndex/Images/index_logo.svg?inlineN'

import StatusIndexChapterTitle  from '@/components/Pages/Home/CharacterStatusIndex/Images/chapter_title.svg?inlineN'
import StatusIndexLengthOfStay  from '@/components/Pages/Home/CharacterStatusIndex/Images/length_of_stay_title.svg?inlineN'
import StatusIndexItemsTitle    from '@/components/Pages/Home/CharacterStatusIndex/Images/items_title.svg?inlineN'
import StatusIndexSonarTitle    from '@/components/Pages/Home/CharacterStatusIndex/Images/sonar_title.svg?inlineN'

import StatusIndexSonarImage    from '@/components/Pages/Home/CharacterStatusIndex/Images/sonar-image.svg?inlineN'

import ChapterBanner            from '@/components/Pages/Home/CharacterStatusIndex/ChapterBanner.vue'

import CharacterItemListItem    from '@/components/Pages/Home/CharacterStatusIndex/CharacterItemListItem.vue'

import {GetMe}  from '@/graphql/queries/User.graphql'
import {GetMyCharacterLevel} from '@/graphql/queries/CharacterLevel.graphql'
import {GetCharacterItemStore} from '@/graphql/queries/CharacterItemStore.graphql'

export default {
  components : {
    ChapterBanner,
    CharacterStatusIndexLogo,
    StatusIndexChapterTitle,
    StatusIndexLengthOfStay,
    StatusIndexItemsTitle,
    StatusIndexSonarTitle,

    StatusIndexSonarImage,

    CharacterItemListItem
  },

  data(){
    return {
      timeIntervalId      : null,
      dateTime            : '2017年11月22日 23:39',
      characterLevelSlug  : 'level1',
      progressPercent     : 50,
      progressText        : '10/5000',
      lengthOfStay        : 500, //day_count
      items               : [],
      hasVisibleItems     : false,
    };
  },

  apollo : {
    me: {
      query: GetMe,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },
      // fetchPolicy: 'no-cache'
    },

    myCharacterLevel : {
      query : GetMyCharacterLevel,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },
    },

    characterItemStoreList : {
      query : GetCharacterItemStore,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },
    }
  },

  watch : {
    progressPercent : {
      handler(){
        this.setProgressBarPercent();
      },
      immediate: true
    },

    me : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.lengthOfStay = data.primaryCharacter.stamp_card.day_count;
      },
      immediate: true
    },

    myCharacterLevel : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.characterLevelSlug = data.current_level.slug;

        this.progressText = data.zero_current+'/'+data.zero_end;

        this.progressPercent = (data.zero_current / data.zero_end) * 100;
      },
      immediate: true
    },

    characterItemStoreList : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data.length === 0){
          this.hasVisibleItems = false;
        }else{
          this.hasVisibleItems = true;
        }
      },
      immediate: true
    }
  },

  methods : {
    setProgressBarPercent(){
      if(typeof this.$refs.progressBarValue === 'undefined') return;

      this.$refs.progressBarValue.style.width = ""+this.progressPercent+"%";
    },

    initDateTimeView(){
      const dateFormat = 'YYYY年MM月DD日 HH時mm分';

      this.dateTime = this.$moment().format(dateFormat);

      this.timeIntervalId = setInterval(() => {
        this.dateTime = this.$moment().format(dateFormat);
      }, 1000 * 15);
    }
  },

  created(){
    this.initDateTimeView();
  },

  beforeCreate(){
    if(this.timeIntervalId !== null){
      clearInterval(this.timeIntervalId);
    }
  },

  beforeDestroy(){
    if(this.timeIntervalId !== null){
      clearInterval(this.timeIntervalId);
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-section{
  &-character-status-index{
    .logo-header{
      width:96%;
      margin:0 auto;
      background-color:#c2a78f;
      border-radius:4px;
      text-align:center;
      padding:.5rem 0 .2rem;

      svg{
        max-width:70%;
        fill:#8e5b17;
      }
    }

    .local-date{
      width:96%;
      margin:.5rem auto;
      background-color:#c2a78f;
      border-radius:4px;
      text-align:center;
      padding:.3rem 0;

      @include until(375px) {
        font-size:.8rem;
      }
    }

    .infomation-items{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content:space-between;
      width:96%;
      margin:0 auto;
      
      .infomation-set{
        margin-bottom:.5rem;
        width:49%;
        
        .title-logo{
          svg{
            fill:#CAB090;
          }
        }

        &-chapter{
          .chapter-banner{
            border-bottom:2px solid #A07A35;
          }

          .progress-bar{
            margin-top:.2rem;
            background-color:#B78660;
            border-radius: 4px;
            padding:.1rem .3rem;
            position: relative;
            
            > p.initial-text{
              color:#B78660;
            }

            > p.value-text{
              box-sizing: border-box;
              width:100%;
              z-index:3;
              padding:.1rem .3rem;
              position: absolute;
              top:0;
              left:0;
              text-align: right;
              color: #666565;
            }

            &-value{
              z-index:2;
              position: absolute;
              top:0;
              left:0;
              background-color:#B76C33;
              border-radius: 4px 0 0 4px;
              height:27.19px;
              width:0;

              &-full{
                border-radius: 4px 4px 4px 4px;
              }
            }
          }
        }

        &-length-of-stay{
          .stay-counter{
            background-color: #B78660;
            border-radius: 4px;
            text-align: center;

            .value-field{
              width:98%;
              color:#726047;
              font-size:1.6rem;
              line-height: 2rem;
              position: relative;

              &::after{
                content:" ";
                position:absolute;
                top:50%;
                left:0;
                width:100%;
                border-top:2px solid #B78660;
              }
            }

            .title-field{
              width:98%;
              border-top:2px solid #BC9173;
              color:#726047;
              font-size:.8rem;
            }
          }
        }

        &-item-store{
          @include until(375px) {
            font-size:.78rem;
          }

          .item-list{
            .pa-item-list-item{
              margin-top:.4rem;

              &:first-child{
                margin-top:0;
              }
            }
            .no-items{
              margin-top:-.4rem;
              color: #A08E7C;
              text-align: center;
              font-size:1.2rem;
              line-height: 3rem;
            }

            .no-item-description{
              padding:.2rem .1rem;
              border-top:1px solid #A08E7C;
              color: #A08E7C;
              font-size:.8rem;
              text-align: left;
            }
          }
        }

        &-sonar{
          .sonar-image{
            text-align: center;

            svg{
              width:95%;
              fill:#c4ab90;
            }
          }

          .status-text{
            text-align: center;
            color:#A08E7C;
            font-size:1.1rem;
            line-height: 1.5rem;
          }
        }
      }
    }
  }
}
</style>